import * as Yup from "yup";

export const stepValidte = Yup.object().shape({
  text: Yup.string().required("وارد کردن متن الزامی است"),
});
